import React, { useContext, useEffect, useState } from 'react';

import Select from '../../components/select';
import Options from '../../components/select/options';
import { IOptionsProps } from '../../@interfaces';
import RelatorioAnaliticoRonda from './relatorioanaliticoronda';
import AuthContext from '../../contexts/auth';
import ToastContext from '../../contexts/toast';
import { CustumerContext } from '../../contexts/custumer';

const relatorios = [
  { label: 'Relatório Analítico Ronda', value: 'relatorio_analitico_ronda', idSar: 19530 }
];




const Relatorios: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string | number | null>(null);
  const { acessos } = useContext(AuthContext);
  const { showErrorToast } = useContext(ToastContext);
  const { id_current_custumer }= useContext(CustumerContext)

  
  useEffect(() => {
    setSelected(null);
    setIsOpen(false);
  }, [id_current_custumer])


  function handleSelectOption(value: string | number) {
    setSelected(value);
  }

  

  const relatoriosPermitidos = relatorios.filter(i => acessos.includes(i.idSar));

  return (
    <div className="p-2">
      <div className='w-[300px]'>
        <Select
          onOpenOptions={()=> {
            if(relatoriosPermitidos.length === 0) return showErrorToast("Nenhum relatório permitido")
            setIsOpen(true);
          }}
          label={selected ? relatorios.find(r => r.value === selected)?.label : 'Escolha o relatório'}
          
        />
      </div>

      {selected === "relatorio_analitico_ronda" && <RelatorioAnaliticoRonda />}

      
      {isOpen && (
        <Options
          close={() => setIsOpen(false)}
          selectOption={handleSelectOption}
          itens={relatoriosPermitidos}
          sortAlphabetically
        />
      )}

      
    </div>
  )
}

export default Relatorios;